// Auto-generated search result templates map
import figureTemplate from "/home/runner/work/glossaryCanopy/glossaryCanopy/content/search/_result-figure.mdx";
export const figure = figureTemplate;
import articleTemplate from "/home/runner/work/glossaryCanopy/glossaryCanopy/content/search/_result-article.mdx";
export const article = articleTemplate;
export default { figure, article };